export const API_END_POINTS = {
  //Params
  quePage: "?page=",
  andPage: "&page=",
  andSize: "&size=12",

  //upload
  uploadSingle: "/upload/single",
  uploadMultiple: "/upload/multiple",

  //Auth
  loginRequest: "/auth/login",
  triggerEmailForForgotPasswordRequest: "/auth/change-password/",
  logoutRequest: "/auth/logout",
  checkLinkForCreatePasswordRequest: "/auth/check-link?slug=",
  forgotPasswordRequest: "/auth/forgot-password",
  changePasswordRequest: "/auth/reset-password",

  //Policy API
  getPolicy: "/content",

  //Delete account API
  deleteAccount: "/auth/delete-request",
  deleteConfimation: "auth/delete-user/app",

  //Staff
  staffList: "/staff/get-all-users",
  staffStatusChange: "/staff/staff-status-change/",
  addStaff: "/staff/add-staff",
  editStaff: "/staff/edit-staff-details",
  individualStaff: "/staff/get-individual-staff/",
  deleteStaff: "/staff/delete-staff/",

  //Content Management -> Product Training Programs
  productTrainingList: "/product-training/get-all-product-training",
  editProductTrainingListStatus:
    "/product-training/product-training-visible_status",
  deleteProductTraining: "/product-training/delete-product-training",
  productTrainingGetCategory: "/product-training/get-category",
  individualProductTraining:
    "/product-training/get-individual-product-training",
  productTrainingGetSubCategory: "/product-training/get-sub-category",
  addProductTraining: "/product-training/add-product-training",
  editProductTraining: "/product-training/edit-product-training-details",

  //Content Management -> Industry Training Programs
  industryTrainingList:
    "/industry-training-program/get-all-industry-training-program",
  editIndustryTrainingListStatus:
    "/industry-training-program/industry-training-program-visible_status",
  deleteIndustryTraining:
    "/industry-training-program/delete-industry-training-program",
  individualIndustryTraining:
    "/industry-training-program/get-individual-industry-training-program",
  addIndustryTraining:
    "/industry-training-program/add-industry-training-program",
  industryTrainingGetCategory: "/industry-training-program/get-industry-types",
  editIndustryTraining:
    "/industry-training-program/edit-industry-training-program-details",

  //Content Management -> Banner/Promotions
  bannerList: "/banner/get-all-banner",
  editBannerStatus: "/banner/banner-visible_status",
  deleteBanner: "/banner/delete-banner",
  individualBanner: "/banner/get-individual-banner",
  addBanner: "/banner/add-banner",
  editBanner: "/banner/edit-banner-details",

  //Content Management -> FAQs
  faqList: "/faq/get-all-faq",
  editFAQStatus: "/faq/faq-visible_status",
  deleteFAQ: "/faq/delete-faq",
  individualFAQ: "/faq/get-individual-faq",
  addFAQ: "/faq/add-faq",
  editFAQ: "/faq/edit-faq-details",

  //Content Management -> Offer Code
  offerCodeList: "/offer-code/get-all-offer-code",
  editOfferCodeStatus: "/offer-code/offer-code-status",
  deleteOfferCode: "/offer-code/delete-offer-code",
  individualOfferCode: "/offer-code/get-individual-offer-code",
  addOfferCode: "/offer-code/add-offer-code",
  editOfferCode: "/offer-code/edit-offer-code-details",

  //User Management
  userManagementCompany: "/auth/usermanagement/company",
  userManagementIndustry: "/company/get-industry-types",
  userManagementList: "/auth/usermanagement/list",
  individualUser: "/auth/usermanagement/get-individual-user",
  userCreditHistory: "/auth/user-credit-history",
  editUser: "/auth/usermanagement/edit-user-details",
  deleteUser: "/auth/usermanagement/delete-user",
  userStatusChange: "/auth/usermanagement",
  userPurchaseHistory: "/auth/usermanagement/get-all-purchase-history",

  //Contact management
  getContactRequestList: "/contact-us-admin/?page=",
  getContactDetailsRequest: "/contact-us-admin/",
  postReplyToUserRequest: "/contact-us-admin/send-reply/",
  closeUserChatRequest: "/contact-us-admin/",

  //Product Catalog
  productList: "/product-catalog/get-all-product-catalog",
  individualProduct: "/product-catalog/get-individual-product-catalog",
  productCategory: "/product-catalog/get-category",
  productSubCategory: "/product-catalog/get-sub-category",
  productFiltrationTypes: "/product-catalog/get-filteration-types",
  deleteProduct: "/product-catalog/delete-product-catalog",
  productStatusChange: "/product-catalog/product-catalog-status",
  editProduct: "/product-catalog/edit-product-catalog",
  addProduct: "/product-catalog/add-product-catalog",

  //companyManagement
  companyList: "/company/get-all-company",
  companyManagementCompanies: "/company/get-company-types",
  companyManagementIndustries: "/company/get-industry-types",
  individualCompany: "/company/get-individual-company",
  editCompany: "/company/edit-company",
  addCompany: "/company/add-company",
  addCompanyUser: "/company/add-company-user",
  companyUsersList: "/auth/get-users-by-company",
  companyPurchaseHistory: "/company/get-purchase-history",
  companyServiceHistory: "/company/get-all-credit-history",
  deleteCompany: "/company/delete-company",
  companyStatusChange: "/company/company-status-change",
  checkEmail: "/auth/check-email",
  mapExistingUser: "/company/user-without-company-id",
  subscription: "/company/subscription",
  manageUsersCM: "/company/manage-users",
  sendInvite: "/company/send-invite",
  editUserCompany: "/company/edit-user-company",
  companiesList : "/company/companies/export",

  //country code
  fetchcountryCodes : "/smart-support/get-country-list",

  //Choose KG
  becomeDistributorList: "/choose-kg/get-all-become-distributer",
  newsletter: "/choose-kg/get-all-newsletter-emails",
  contactList : "/choose-kg/get-all-contact-us",
  inquiryRequest : "/choose-kg/get-all-inquiry-requests",
  individualQuoteRequest : "/choose-kg/get-inquiry-request-products-by-inquiry-id",

  //Mining KG
  miningNewsletter: "/mining-kg/get-all-newsletter-emails",
  miningContactList: "/mining-kg/get-all-contact-us",
  miningSpeakBearingList: "/mining-kg/get-all-speak-to-bearing-expert",
 
  //request Module

    //Mining KG
  miningNewsletter: "/mining-kg/get-all-newsletter-emails",
  miningContactList: "/mining-kg/get-all-contact-us",
  miningSpeakBearingList: "/mining-kg/get-all-speak-to-bearing-expert",

  //-> Purchase Request
  purchaseRequestList: "/product-catalog/get-all-purchase-request",
  individualPurchaseRequest: "/product-catalog/get-individual-purchase-request",

  //-> Maintenance Request
  maintenanceRequestList: "/smart-support/maintenance-assessment-req/list",
  individualMaintenanceRequest: "/smart-support/maintenance-assessment-req",
  closeMaintenanceRequest: "/smart-support/close-maintenance-assessment-request",

  //-> Call Request
  callRequestList: "/smart-support/engineering-consultation-req/list",
  individualCallRequest: "/smart-support/engineering-consultation-req",

  //condition monitoring request
  conditionMonitoringRequestList : "/smart-support/condition-monitoring-req/list",
  individualConditionMonitoringReq : "smart-support/condition-monitoring-req",
  closeConditionMonitoringReq : "/smart-support/close-condition-monitoring-req",

  //-> Call Request
  creditRequestList: "/smart-support/credit-req/list",
  individualCreditRequest: "/smart-support/credit-req",
  closeCallRequest: "/smart-support/close-engineering-consultation-request",

  //Request
  getPrimaryModeOfFailure: "/smart-support/get-primary-mode-of-failure",
  getAllfailureAnalysisRequest: "/smart-support/get-all-failure-analysis",
  getIndividualfailureAnalysisRequest: "/smart-support/get-failure-analysis",
  addInvestigation: "/smart-support/create-bearing-component",
  fetchInvestigation: "/smart-support/bearingComponent",
  fetchAssetDetails: "/smart-support/modeOfFailure",
  fetchAnalysis: "/smart-support/bearingAnalysis",
  fetchRecommendations: "/smart-support/recommendation",
  getModeOfFailure: "/smart-support/get-mode-of-failure",
  getBearingComponent: "/smart-support/get-bearing-component-list",
  addAssetDetails: "/smart-support/create-mode-of-failure",
  addBearingDetails: "/smart-support/create-bearing-analysis",
  addRecommendation: "/smart-support/create-recommendation",
  editInvestigation: "/smart-support/bearing-component/update",
  editAssetDetails: "/smart-support/mode-of-failure/update",
  editBearingDetails: "/smart-support/bearing-analysis/update",
  editRecommendation: "/smart-support/recommendation/update",
  bearingType: "/smart-support/bearing-data",
  lubricationType: "/smart-support/lubricant-data",
  previewReportData: "/smart-support/failure-analysis-report",
  sendReport: "/smart-support/send-far-report",
  downloadFarReport: "/smart-support/get-far-report-download/far",
  editSecondayDetail: "smart-support/secondary-mode-of-failure/update",
  addSecondaryDetail: "/smart-support/create-secondary-mode-of-failure",
  getSecondayDetail: "/smart-support/get-secondary-mode-of-failure",
  fetchSecondaryDetail:"/smart-support/secondaryModeOfFailure",
  getFarPdfReport : "/smart-support/get-all-far-for-report/far",
  //-> Dashboard
  cardDetails: "/smart-support/dashboard/statistics",
  maintenanceRequestGraph: "/smart-support/dashboard-maintenance-request",
  purchaseRequestGraph: "/smart-support/dashboard-purchase-request",
  callRequestGraph: "/smart-support/dashboard-call-request",
  FARGraph: "/smart-support/dashboard-failure-analysis-request",
  consultationRequestGraph : "/smart-support/dashboard-consultation-request",
  conditionMonitoringRequestGraph : "/smart-support/dashboard-condition-monitoring-request",
};
